export const ourProducts = {
    ARM: 'ՄԵՐ ԱՊՐԱՆՔՆԵՐԸ',
    ENG: 'OUR PRODUCTS',
    RUS: 'НАШИ ПРОДУКТЫ'
}